import { axiosClient } from "@/shared/api/axios-client";

/**
 * Catálogo administrable de categorías de documento · proyección visible
 * del enum CategoriaDocumento del backend. Las categorías con
 * `esSistema=true` están atadas al enum y NO se pueden eliminar.
 */
export interface CategoriaDocumentoDto {
  id: string;
  codigo: string;
  nombre: string;
  descripcion: string | null;
  extensiones: string[];
  tamanoMaximoBytes: number;
  esSistema: boolean;
  activa: boolean;
  orden: number;
}

export interface CrearCategoriaInput {
  codigo: string;
  nombre: string;
  descripcion: string | null;
  extensiones: string[];
  tamanoMaximoBytes: number;
  orden: number;
}

export interface EditarCategoriaInput {
  nombre: string;
  descripcion: string | null;
  extensiones: string[];
  tamanoMaximoBytes: number;
  orden: number;
}

const BASE = "/api/admin/categorias-documento";

export interface ListarCategoriasParams {
  busqueda?: string;
  soloActivas?: boolean;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + conteos del catálogo completo para el header. */
export interface PaginaCategoriasDocumento {
  items: CategoriaDocumentoDto[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
  totalActivas: number;
  totalSistema: number;
}

export async function listarCategoriasDocumento(
  params: ListarCategoriasParams = {},
): Promise<PaginaCategoriasDocumento> {
  const { data } = await axiosClient.get<PaginaCategoriasDocumento>(BASE, {
    params,
  });
  return data;
}

export async function crearCategoria(
  input: CrearCategoriaInput,
): Promise<CategoriaDocumentoDto> {
  const { data } = await axiosClient.post<CategoriaDocumentoDto>(BASE, input);
  return data;
}

export async function editarCategoria(
  id: string,
  input: EditarCategoriaInput,
): Promise<CategoriaDocumentoDto> {
  const { data } = await axiosClient.patch<CategoriaDocumentoDto>(
    `${BASE}/${id}`,
    input,
  );
  return data;
}

export async function cambiarEstadoCategoria(
  id: string,
  activa: boolean,
): Promise<CategoriaDocumentoDto> {
  const { data } = await axiosClient.post<CategoriaDocumentoDto>(
    `${BASE}/${id}/estado`,
    { activa },
  );
  return data;
}

export async function eliminarCategoria(id: string): Promise<void> {
  await axiosClient.delete(`${BASE}/${id}`);
}
